import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PycnometerProfileSummary } from '@models/pycnometer-profile.interface';

interface FieldChangeEvent {
  fieldKey: string;
  value: string;
}

@Component({
  selector: 'app-job-request-test-pycnometer-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-request-test-pycnometer-detail.component.html',
  styleUrl: './job-request-test-pycnometer-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobRequestTestPycnometerDetailComponent implements OnInit {
  @Input({ required: true }) testKey = '';
  @Input({ required: true }) fieldValueByKey!: (testKey: string, fieldKey: string) => string;
  @Input({ required: true }) isProfilePickerOpen = false;
  @Input() pycnometerProfiles: PycnometerProfileSummary[] = [];
  @Input() pycnometerProfilesLoading = false;
  @Input() pycnometerProfilesError = '';
  @Input() runIndices: number[] = [1, 2, 3, 4];
  @Input({ required: true }) runVp!: (testKey: string, run: number) => string;
  @Input({ required: true }) runSg!: (testKey: string, run: number) => string;
  @Input({ required: true }) averageSg!: (testKey: string) => string;
  @Input({ required: true }) averageAbsoluteVolume!: (testKey: string) => string;
  @Input({ required: true }) averageDensity!: (testKey: string) => string;

  @Output() fieldChanged = new EventEmitter<FieldChangeEvent>();
  @Output() toggleProfilePicker = new EventEmitter<void>();
  @Output() useProfile = new EventEmitter<number>();

  ngOnInit(): void {
    const hasProfileValues = this.fieldValueByKey(this.testKey, 'profileName').trim() 

    if (!hasProfileValues) {
      const defaultProfile = this.pycnometerProfiles.find(profile =>
      profile.name?.trim().toLowerCase() === 'mud lab'
      );

      if (defaultProfile) {
        this.useProfile.emit(defaultProfile.id);
      }
    }

    
  }

  protected onFieldInput(fieldKey: string, value: string): void {
    this.fieldChanged.emit({ fieldKey, value });
  }
}
